import axios from "axios";

// Backend URL resolution — runtime, hostname-based.
// This is intentionally resilient to platform env-var rewrites during deploy:
// no matter what REACT_APP_BACKEND_URL is set to at build time, production
// hosts always talk to the production backend, and everything else uses preview.
const PROD_BACKEND =
  process.env.REACT_APP_PROD_BACKEND_URL || "https://consult.healthcircles.care";
const PREVIEW_BACKEND =
  process.env.REACT_APP_BACKEND_URL || "https://consult-ease.preview.emergentagent.com";

const PROD_HOST_PATTERNS = [
  /^care\.healthcircles\.care$/i,
  /^vitals-hub-126\.emergent\.host$/i,
  /\.healthcircles\.care$/i,
  /\.emergent\.host$/i,
];

const resolveBackend = () => {
  if (typeof window === "undefined") return PREVIEW_BACKEND;
  const host = window.location.hostname;
  const isProd = PROD_HOST_PATTERNS.some((r) => r.test(host));
  return isProd ? PROD_BACKEND : PREVIEW_BACKEND;
};

const BACKEND_URL = resolveBackend();
export const API = `${BACKEND_URL}/api`;
export const BACKEND_ENV = BACKEND_URL === PROD_BACKEND ? "production" : "preview";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("hc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("hc_token");
      localStorage.removeItem("hc_user");
      if (!window.location.pathname.startsWith("/login") &&
          !window.location.pathname.startsWith("/signup") &&
          !window.location.pathname.startsWith("/awareness") &&
          window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const drName = (name = "") => {
  const n = String(name || "").trim();
  if (!n) return "";
  return /^dr\.?\s/i.test(n) ? n : `Dr. ${n}`;
};
